import store from '@/store'

function clearState () {
  store.commit('plot/setId', null)
  store.commit('plot/clearState', 'localization')
  store.commit('plot/clearState', 'team')
  store.commit('plot/clearTmp', 'plot')
  store.commit('plot/clearState', 'plot')
  store.commit('plot/clearState', 'typeInfo')
}

export default clearState
